
const consts = 
{
    numPoolBalls: 15, // The number of pool balls.
    lclStrgKeyPrevNames: "PreviousPlayers"
}

export default consts;